<template>
  <div>
    <div v-if="!homePage" class="exhibition-content">

      <div class="main-container">
        <h1 id="exhibition-title">{{ this.name }}</h1>
        <img v-if="this.resources[0]" class="header-image" v-bind:src="resourceUrls[0]" alt="Header Image" />

        <section class="resources-section">
          <div v-for="(resource, index) in resources" :key="index" class="resource-card polaroid" @click="showResourceModal(resource, resourceUrls[index])">
            <div class="polaroid-inner">
              <div class="polaroid-photo-wrap">
                <img :src="resourceUrls[index]" alt="Resource Image" class="polaroid-photo" />
              </div>
              <div class="polaroid-caption">
                <div class="caption-title">{{ resource.title }}</div>
              </div>
            </div>
          </div>
        </section>

        <footer class="exhibition-footer">
          <span>2021 ALPA TECHNOLOGIES</span>
          <span>Mentions Legales</span>
          <span>Fattu in Corsica</span>
        </footer>
      </div>
    </div>
    <div class="home-section" v-else>
      <component :is="selectedTemplate" :homeImage="homeImage" @exit="exitHomePage"></component>
    </div>

    <!-- New Modal for enlarged resource -->
    <div v-if="isModalVisible" class="modal-overlay" @click="closeResourceModal">
      <div class="modal-polaroid" @click.stop>
        <div class="polaroid-inner-large">
          <button class="modal-close-btn" @click="closeResourceModal">&times;</button>
          <div class="polaroid-photo-wrap-large">
            <img :src="selectedResourceForModal.url" alt="Enlarged resource" class="polaroid-photo-large" />
          </div>
          <div class="polaroid-caption-large">
            <div class="caption-title-large">{{ selectedResourceForModal.title }}</div>
            <div class="caption-desc-large">{{ selectedResourceForModal.description }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
<script>
import axios from "axios";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";
import Modele_2 from "../../components/Models/Modele_2.vue";
import Modele_3 from "../../components/Models/Modele_3.vue";
import Modele_1 from "../../components/Models/Modele_1.vue";
import Modele_4 from "../../components/Models/Modele_4.vue";
import Modele_5 from "../../components/Models/Modele_5.vue";
import Modele_6 from "../../components/Models/Modele_6.vue";
import Modele_7 from "../../components/Models/Modele_7.vue";

gsap.registerPlugin(ScrollTrigger);

export default {
  layout: "default",
  components: {
    Modele_2,
    Modele_3,
    Modele_1,
    Modele_4,
    Modele_5,
    Modele_6,
    Modele_7
  },
  props: [
    'homePageProps',
    'exhibitId'
  ],
  data() {
    return {
      id: this.$route.params.id ?? this.exhibitId,
      resources: [],
      name: "",
      userName: "",
      headImage: [],
      selectedTemplate: "",
      homePage: this.homePageProps ?? true,
      homeImage: {},
      resourceUrls: [],
      isModalVisible: false,
      selectedResourceForModal: null,
    };
  },
  methods: {
    showResourceModal(resource, url) {
      this.selectedResourceForModal = {
        ...resource,
        url: url
      };
      this.isModalVisible = true;
    },
    closeResourceModal() {
      this.isModalVisible = false;
      this.selectedResourceForModal = null;
    },
    getHeadImage(index) {
      let url = `${process.env.VUE_APP_BASEURL}/s3Resource/${this.resources[index].name}`;
      return url;
    },
    async fetchResources() {
      if (this.resources.length === 0) {
        await this.getResources();
      }
      const urls = this.resources.map(resource => `${process.env.VUE_APP_BASEURL}/s3Resource/${resource.name}`);
      try {
        const responses = await Promise.all(urls.map(url => axios.get(url)));
        this.resourceUrls = responses.map(response => response.data);
      } catch (error) {
        console.error("Erreur lors de la récupération des URLs des ressources", error);
      }
    },
    async getUserName() {
      let url = `${process.env.VUE_APP_BASEURL}/user/${this.id}`;
      let response = await axios.get(url);
      this.userName = response.data.name;
    },
    async getHomeImage() {
      try {
        let url = `${process.env.VUE_APP_BASEURL}/exhibit_home/${this.$route.params.id ?? this.exhibitId}`;
        let response = await axios.get(url);
        this.homeImage = response.data[0];
      } catch (error) {
        console.log(error)
      }
    },
    async getModel() {
      try {
        let url = `${process.env.VUE_APP_BASEURL}/model/${this.$route.params.id ?? this.exhibitId}`;
        let response = await axios.get(url);
        if (response.data.length > 0) {
          this.selectedTemplate = response.data[0].model;
          this.selectedTemplate = this.selectedTemplate.replace(/è/g, 'e').replace(/\s+/g, '_');
        }
      } catch (error) {
        console.log(error);
      }
    },
    exitHomePage() {
      this.homePage = false;
      setTimeout(() => {
        this.startAnimation();
      }, 2000)
    },
    async getExhibitName() {
      let url = `${process.env.VUE_APP_BASEURL}/exhibit/${this.id}`;
      let response = await axios.get(url);
      this.name = response.data.exhibit_name;
    },
    startAnimation() {
      // GSAP animation code...
    },
    async getResources() {
      let exhibitId = this.$route.params.id ?? this.exhibitId;
      try {
        let resourcesUrl = `${process.env.VUE_APP_BASEURL}/resources`;
        let response = await axios.post(resourcesUrl, { exhibitId });
        let allResources = response.data;
        let galleryUrl = `${process.env.VUE_APP_BASEURL}/galleryResources/${exhibitId}`;
        let galleryResponse = await axios.get(galleryUrl);
        let galleryResourceIds = galleryResponse.data.map(res => res.resource_id);
        this.resources = allResources.filter(resource =>
          galleryResourceIds.includes(resource.id)
        );
      } catch (error) {
        console.error("Error fetching resources:", error);
      }
    }
  },
  created() {
    this.getHomeImage();
    this.getResources();
    this.fetchResources();
    this.getExhibitName();
    this.getUserName();
    this.getModel();
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Bungee&family=Kalam:wght@400;700&display=swap');

:root {
  --bg: #111427;
  --paper: #ffffff;
  --ink: #1f2937;
  --shadow: rgba(0,0,0,.28);
  --accent1: #ff3d81;
  --accent2: #00e0ff;
}
.exhibition-content {
  --bg: #111427;
  --paper: #ffffff;
  --ink: #1f2937;
  --shadow: rgba(0,0,0,.28);
  --accent1: #ff3d81;
  --accent2: #00e0ff;
  min-height: 100vh;
  background:
    radial-gradient(800px 300px at 10% 10%, rgba(255,61,129,.20), transparent 60%),
    radial-gradient(600px 220px at 90% 20%, rgba(0,224,255,.18), transparent 60%),
    repeating-linear-gradient(45deg, rgba(255,255,255,.06) 0 8px, transparent 8px 16px),
    linear-gradient(180deg, #0b0e22, #161a37);
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-x: hidden;
}
.main-container {
  color: #e5e7eb;
  width: 100%;
  max-width: 1200px;
  padding: 48px 24px 64px;
}

#exhibition-title {
  font-family: 'Bungee', cursive;
  font-size: clamp(2rem, 5vw, 3.5rem);
  text-align: center;
  margin: 0 0 32px;
  color: #fff;
  text-shadow: 0 0 5px var(--accent2), 0 0 10px var(--accent2), 0 0 20px var(--accent1), 0 4px 5px rgba(0,0,0,.5);
}

.header-image {
  width: min(100%, 1100px);
  aspect-ratio: 21/9;
  object-fit: cover;
  border-radius: 18px;
  box-shadow: 0 24px 60px var(--shadow);
  margin: 0 auto 48px;
  display: block;
}
.resources-section {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 34px;
}
.polaroid {
  position: relative;
  transform: rotate(var(--rot, 0deg));
  transform-origin: center top;
  transition: transform .35s ease, box-shadow .35s ease;
  z-index: 0;
  user-select: none;
}
.polaroid::before{
  content: "";
  position: absolute;
  left: 12%;
  right: 12%;
  bottom: -14px;
  height: 26px;
  background: radial-gradient(closest-side, rgba(0,0,0,.35), rgba(0,0,0,0));
  filter: blur(6px);
  opacity: .55;
  transform: rotate(calc(var(--rot, 0deg) * .35));
  z-index: -1;
}
.polaroid:nth-child(7n+1){ --rot: -3deg; }
.polaroid:nth-child(7n+2){ --rot: 2.2deg; }
.polaroid:nth-child(7n+3){ --rot: -1.8deg; }
.polaroid:nth-child(7n+4){ --rot: 1.6deg; }
.polaroid:nth-child(7n+5){ --rot: -2.4deg; }
.polaroid:nth-child(7n+6){ --rot: 0.8deg; }
.polaroid-inner{
  position: relative;
  background: linear-gradient(180deg, #ffffff, #fcfbf7 40%, #ffffff);
  border-radius: 8px;
  box-shadow: 0 14px 28px rgba(0,0,0,.28);
  --frameTop: 12px;
  --frameSide: 12px;
  --frameBottom: 44px;
  padding: var(--frameTop) var(--frameSide) var(--frameBottom);
}
.polaroid-inner::before{
  content: "";
  position: absolute;
  inset: 0;
  border-radius: 8px;
  background:
    radial-gradient(1px 1px at 20% 30%, rgba(0,0,0,.06), transparent 45%),
    radial-gradient(1px 1px at 70% 80%, rgba(0,0,0,.05), transparent 45%),
    radial-gradient(1px 1px at 40% 60%, rgba(0,0,0,.04), transparent 45%),
    linear-gradient( to bottom right, rgba(0,0,0,.05), transparent 40% );
  opacity: .22;
  pointer-events: none;
  mix-blend-mode: multiply;
}
.polaroid-inner::after{
  content: "";
  position: absolute;
  inset: 0;
  border-radius: 8px;
  background:
    linear-gradient( to top, rgba(255,255,255,.35), transparent 30% ),
    linear-gradient( to bottom right, rgba(0,0,0,.05), transparent 60% );
  opacity: .35;
  pointer-events: none;
}
.polaroid-photo-wrap{
  position: relative;
  width: 100%;
  aspect-ratio: 1 / 1;
  background: #0f172a;
  overflow: hidden;
  border-radius: 4px;
  box-shadow: 0 0 0 1px rgba(0,0,0,.06) inset, 0 10px 18px rgba(0,0,0,.18) inset;
}
.polaroid-photo-wrap::after{
  content: "";
  position: absolute;
  inset: 0;
  background:
    radial-gradient(100% 60% at 50% 0%, rgba(255,255,255,.35), transparent 60%),
    linear-gradient( to bottom, transparent 70%, rgba(0,0,0,.15) 100% );
  pointer-events: none;
  mix-blend-mode: screen;
}
.polaroid-photo{
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.polaroid-caption{
  margin-top: 10px;
  text-align: center;
  color: var(--ink);
}
.caption-title{
  font-family: 'Kalam', cursive;
  font-weight: 700;
  font-size: 1.2rem;
  color: #2a2a2a;
  letter-spacing: .5px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.polaroid:hover{
  transform: rotate(0deg) translateY(-6px) scale(1.02);
  z-index: 3;
  cursor: pointer;
}
.exhibition-footer {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  margin-top: 48px;
  color: #cbd5e1;
}

/* Modal Styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(17, 20, 39, 0.9);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  backdrop-filter: blur(5px);
  transition: opacity 0.3s ease;
  padding: 20px;
}

@keyframes fadeInScale {
  0% {
    transform: scale(0.8) rotate(5deg);
    opacity: 0;
  }
  100% {
    transform: scale(1) rotate(-2deg);
    opacity: 1;
  }
}

.modal-polaroid {
  animation: fadeInScale 0.4s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
  position: relative;
  max-width: 70vw;
  max-height: 90vh;
}

.polaroid-inner-large {
  position: relative; /* Added for button positioning */
  background: linear-gradient(180deg, #ffffff, #f7f5f2 40%, #ffffff);
  border-radius: 8px;
  box-shadow: 0 25px 50px -12px rgba(0,0,0,.5);
  padding: 20px;
  display: flex;
  flex-direction: column;
  max-height: 85vh;
  overflow: hidden;
}

.polaroid-photo-wrap-large {
  position: relative;
  width: 100%;
  background: #0f172a;
  border-radius: 4px;
  box-shadow: 0 0 0 1px rgba(0,0,0,.06) inset, 0 10px 18px rgba(0,0,0,.18) inset;
  flex-shrink: 0;
}

.polaroid-photo-large {
  width: 100%;
  max-height: 55vh;
  object-fit: contain;
  display: block;
}

.polaroid-caption-large {
  margin-top: 15px;
  padding-right: 10px;
  text-align: center;
  color: var(--ink);
  flex-shrink: 1;
  overflow-y: auto;
  min-height: 0;
}

.caption-title-large {
  font-family: 'Bungee', cursive;
  font-size: clamp(1.5rem, 3vw, 2.2rem);
  color: var(--ink);
  margin: 0;
  line-height: 1.2;
  flex-shrink: 0;
}

.caption-desc-large {
  font-family: 'Kalam', cursive;
  font-weight: 400;
  font-size: clamp(1rem, 2vw, 1.3rem);
  color: #3a3a3a;
  opacity: .9;
  margin-top: 10px;
}

.modal-close-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 30px;
  height: 30px;
  background: rgba(0,0,0,0.3);
  border: 1px solid white;
  border-radius: 50%;
  font-family: sans-serif;
  font-weight: bold;
  font-size: 1.2rem;
  color: white;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  justify-content: center;
  align-items: center;
  line-height: 1;
  box-shadow: none;
  z-index: 10;
}

.modal-close-btn:hover {
  transform: scale(1.1);
  background: rgba(0,0,0,0.6);
}
</style>